function copyAddress() {
  $('.article__share').on('click', function(e) {
    e.preventDefault();

    const url = window.location.href;
    const $tempInput = $('<input>');
    
    $('body').append($tempInput);
    $tempInput.val(url).select();
    document.execCommand('copy');
    $tempInput.remove();
  });
}
copyAddress();